import { IUserRoles } from '../../Interfaces/IUserRoles';

export enum UserRolesActionType {
  SET_USER_ROLES = 'SET_USER_ROLES',
  CLEAR_USER_ROLES = 'CLEAR_USER_ROLES',
}

export type UserRolesActions = SetUserRolesAction | ClearUserRolesAction;

export interface SetUserRolesAction {
  type: UserRolesActionType.SET_USER_ROLES;
  payload: IUserRoles;
}

export interface ClearUserRolesAction {
  type: UserRolesActionType.CLEAR_USER_ROLES;
}
